/**
 * Stimmen der Pfeifen.
 *
 * Anhang III schreibt die Grundfrequenz nach Schiffslänge vor: je größer das Schiff,
 * desto tiefer der Ton. Das ist kein Beiwerk, sondern eine Lernhilfe, denn wer auf See
 * ein Nebelsignal hört, schätzt an der Tonhöhe die Größe des anderen. Die App erzeugt
 * die Töne deshalb in drei Stimmen, jede innerhalb des Bandes, das der Anhang nennt.
 */

export interface Whistle {
  id: 'gross' | 'mittel' | 'klein'
  name: { de: string; en: string }
  /** Grundfrequenz in Hertz, mit der die App den Ton erzeugt. */
  hz: number
  /** Band aus Anhang III, Abschnitt 1(b), in Hertz. */
  band: [number, number]
  /** Fundstelle in Anhang III (Regelnummer 103 im Korpus). */
  cite: string
}

export const ANNEX_III = 103

export const WHISTLES: Whistle[] = [
  {
    id: 'gross',
    name: { de: 'Schiff ab 200 Metern', en: 'Vessel 200 m or more' },
    hz: 120,
    band: [70, 200],
    cite: 's1:b(i)',
  },
  {
    id: 'mittel',
    name: { de: 'Schiff 75 bis 200 Meter', en: 'Vessel 75 m to 200 m' },
    hz: 240,
    band: [130, 350],
    cite: 's1:b(ii)',
  },
  {
    id: 'klein',
    name: { de: 'Schiff unter 75 Metern', en: 'Vessel under 75 m' },
    hz: 420,
    band: [250, 700],
    cite: 's1:b(iii)',
  },
]

export function whistle(id: Whistle['id']): Whistle {
  const found = WHISTLES.find((w) => w.id === id)
  if (!found) throw new Error(`Pfeife ${id} gibt es nicht`)
  return found
}
